export default {"src":"/_next/static/media/settings-icon.0ce4be6f.svg","height":512,"width":513};